export const MOBILE_NEWS_LIST_TITLE = 19;
export const DESKTOP_NEWS_LIST_TITLE = 16;
export const MOBILE_NEWS_DETAIL_NORMAL = 20;
export const MOBILE_NEWS_DETAIL_LARGE = 24;

/** AI 新聞摘要字體大小 (預設 18px, 放大 22px) */
export const AI_SUMMARY_FONT_NORMAL = 18;
export const AI_SUMMARY_FONT_LARGE = 22;

/** AI 新聞摘要項目符號字體大小 (預設 20px, 放大 24px) */
export const AI_SUMMARY_INDEX_FONT_NORMAL = 20;
export const AI_SUMMARY_INDEX_FONT_LARGE = 24;


// TODO: 鉅亨新聞有很奇怪的字體規則，因為老闆覺得手機字太小，所以需要分開設定，字體放大同時，也需要改變對應的行高，所以需要同時處理

